// see http://stackoverflow.com/a/8809472/2823912
export default function generateGuid() {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); // use high-precision timer if available
    }
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        // oxlint-disable-next-line no-bitwise
        const r = ((d + Math.random() * 16) % 16) | 0;
        d = Math.floor(d / 16);
        // oxlint-disable-next-line no-bitwise
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
